import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import DividingModeFooterActions from './DividingModeFooterActions';
import LockboxProcessingFooterActions from './LockboxProcessingFooterActions';
import MultipleRequestsFooterActions from './MultipleRequestsFooterActions';

const LockboxInfoFooterWrapper = styled(Box)`
  position: sticky;
  margin-top: auto;
  bottom: 0;
`;

const LockboxInfoFooter = () => {
  const { isDividingMode, editableLockbox } = useLockboxDetailsStore();

  const currentActions = useMemo(() => {
    if (isDividingMode) {
      return <DividingModeFooterActions />;
    }

    if (editableLockbox?.isMultipleRecordsWarning && editableLockbox?.lockboxStatus === LockboxStatus.NEW && !isDividingMode) {
      return <MultipleRequestsFooterActions />;
    }

    return <LockboxProcessingFooterActions />;
  }, [isDividingMode, editableLockbox]);

  return (
    <LockboxInfoFooterWrapper
      data-testid="lockbox-processing-footer" 
      background="canvas"
      justify="center"
      height={{ min: 'spacing54' }}
      pad={{ horizontal: 'spacing12' }}
      border={{ size: '1px', color: 'border2', side: 'top' }}
    >
      <Box margin={{ left: 'auto' }} direction="row">
        {currentActions}
      </Box>
    </LockboxInfoFooterWrapper>
  );
};

export default LockboxInfoFooter;
